module.exports = __webpack_public_path__ + "3555a36b7dc547b091b13178a875662e.png";